/**
 * Material Categorization Helper
 * Maps individual materials to their parent categories
 */
if (typeof MaterialCategorizer === 'undefined') {
class MaterialCategorizer {
  constructor() {
    this.materialCategories = null;
    this.materialMap = new Map();
    this.loadMaterialCategories();
  }

  async loadMaterialCategories() {
    try {
      const response = await fetch(window.materialCategoriesUrl || '/assets/material-categories.json');
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      this.materialCategories = await response.json();
      this.buildMaterialMap();
    } catch (error) {
      console.error('Failed to load material categories:', error);
      this.materialCategories = {};
    }
  }

  buildMaterialMap() {
    if (!this.materialCategories) return;

    // Build a reverse map from material to category
    Object.entries(this.materialCategories).forEach(([category, materials]) => {
      materials.forEach(material => {
        this.materialMap.set(material.toLowerCase(), category);
      });
    });
  }

  getCategory(material) {
    if (!material || !this.materialCategories) {
      return 'Other';
    }

    const cleanMaterial = material.trim();
    
    // Direct match
    const directMatch = this.materialMap.get(cleanMaterial.toLowerCase());
    if (directMatch) {
      return directMatch;
    }

    // Partial match - check if material contains any known material
    for (const [knownMaterial, category] of this.materialMap.entries()) {
      if (cleanMaterial.toLowerCase().includes(knownMaterial) || 
          knownMaterial.includes(cleanMaterial.toLowerCase())) {
        return category;
      }
    }

    // Keyword-based fallback
    const materialLower = cleanMaterial.toLowerCase();
    
    // Material-specific keywords
    if (materialLower.includes('wood') || materialLower.includes('oak') || materialLower.includes('walnut')) {
      return 'Wood and Derivatives';
    }
    if (materialLower.includes('metal') || materialLower.includes('steel') || materialLower.includes('brass')) {
      return 'Metals';
    }
    if (materialLower.includes('stone') || materialLower.includes('marble') || materialLower.includes('granite')) {
      return 'Stone and Minerals';
    }
    if (materialLower.includes('glass') || materialLower.includes('crystal')) {
      return 'Glass and Derivatives';
    }
    if (materialLower.includes('ceramic') || materialLower.includes('porcelain') || materialLower.includes('clay')) {
      return 'Ceramics and Clays';
    }
    if (materialLower.includes('cotton') || materialLower.includes('linen') || materialLower.includes('wool') || materialLower.includes('silk')) {
      return 'Textiles and Natural Fibers';
    }
    if (materialLower.includes('leather') || materialLower.includes('suede')) {
      return 'Leathers and Skins';
    }
    if (materialLower.includes('plastic') || materialLower.includes('resin') || materialLower.includes('polymer')) {
      return 'Plastics and Composites';
    }

    return 'Other';
  }

  getAllCategories() {
    return this.materialCategories ? Object.keys(this.materialCategories) : [];
  }

  getMaterialsInCategory(category) {
    return this.materialCategories ? this.materialCategories[category] || [] : [];
  }
}

// Global instance
if (!window.materialCategorizer) {
  window.materialCategorizer = new MaterialCategorizer();
}
}
